import { Routes, Route, Link, Navigate } from 'react-router-dom';
import './App.css';

import SipWealthHome from './apps/sip-wealth-calculator/Home';
import SipSupport from './apps/sip-wealth-calculator/Support';
import SipPrivacyPolicy from './apps/sip-wealth-calculator/PrivacyPolicy';
import SipTermsAndConditions from './apps/sip-wealth-calculator/TermsAndConditions';

import MemoryDotHome from './apps/memory-dot/Home';
import MemoryDotSupport from './apps/memory-dot/Support';
import MemoryDotPrivacyPolicy from './apps/memory-dot/PrivacyPolicy';
import MemoryDotTermsAndConditions from './apps/memory-dot/TermsAndConditions';

function Home() {
  return (
    <div className="App">
      <h1>App License Hub</h1>
      <ul>
        <li>
          <Link to="/sip-wealth-calculator">SIP Wealth Calculator</Link>
        </li>
        <li>
          <Link to="/memory-dot">Memory Dot - Brain Training</Link>
        </li>
      </ul>
    </div>
  );
}

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      
      {/* SIP Wealth Calculator Routes */}
      <Route path="/sip-wealth-calculator" element={<SipWealthHome />} />
      <Route path="/sip-wealth-calculator/support" element={<SipSupport />} />
      <Route path="/sip-wealth-calculator/privacy-policy" element={<SipPrivacyPolicy />} />
      <Route path="/sip-wealth-calculator/terms-and-conditions" element={<SipTermsAndConditions />} />
      
      {/* Memory Dot Routes */}
      <Route path="/memory-dot" element={<MemoryDotHome />} />
      <Route path="/memory-dot/support" element={<MemoryDotSupport />} />
      <Route path="/memory-dot/privacy-policy" element={<MemoryDotPrivacyPolicy />} />
      <Route path="/memory-dot/terms-and-conditions" element={<MemoryDotTermsAndConditions />} />
      
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
